import { createFileRoute, redirect } from '@tanstack/react-router';
import { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/expenses_import/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_IMPORTED_RECORD, ['read'], '/unauthorized', context);

    // The expense-import landing page is the imported-records list
    throw redirect({ to: '/expenses_import/expense/import/record', replace: true });
  },
});
